import React from 'react';
import Select, { components } from 'react-select';

const GroupOption = (props) => {
  const { innerRef, innerProps, data, children, isFocused } = props;
  const isGroup = data.isGroup;

  const customInnerProps = isGroup ? {} : innerProps;

  return (
    <div
      ref={innerRef}
      {...customInnerProps}
      style={{
        paddingLeft: isGroup ? '8px' : '18px',
        fontWeight: isGroup ? 'bold' : 'normal',
        cursor: !isGroup ? 'pointer' : 'default',
        backgroundColor: isFocused ? '#f0f0f0' : undefined
      }}
      children={children}
    />
  );
};

const CustomSingleValue = (props) => {
  const renderedValue = props.selectProps.valueComponent ? props.selectProps.valueComponent() : props.data.label;
  return (
    <components.SingleValue {...props}>
      {renderedValue}
    </components.SingleValue>
  );
};

const GroupedSelect = (props) => {

  const components = {
    Option: GroupOption
  };

  if (props.valueComponent) {
    components.SingleValue = CustomSingleValue
  }

  const realValueOption = props.options.find(option => {
    return option.value === props.value
  });

  return (
    <Select
      components={components}
      placeholder={props.placeholder || 'Select a value'}
      {...props}
      value={realValueOption}
    />
  );
};

export default GroupedSelect;
